/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Work_Life_Balance19Inputs */

const en__field_enum_tuda_work_life_balance19 = /** @type {(inputs: _Field_Enum_Tuda_Work_Life_Balance19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions about „Work-Life-Balance“`)
};

const de__field_enum_tuda_work_life_balance19 = /** @type {(inputs: _Field_Enum_Tuda_Work_Life_Balance19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vereinbarkeit von Familie und Beruf „Work-Life-Balance“`)
};

/**
* | output |
* | --- |
* | "Questions about „Work-Life-Balance“" |
*
* @param {_Field_Enum_Tuda_Work_Life_Balance19Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_work_life_balance19 = /** @type {((inputs?: _Field_Enum_Tuda_Work_Life_Balance19Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Work_Life_Balance19Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_work_life_balance19(inputs)
	return de__field_enum_tuda_work_life_balance19(inputs)
});
export { _field_enum_tuda_work_life_balance19 as "_field_enum_TUDA_WORK_LIFE_BALANCE" }